// @flow
import React from "react";
import { withTheme } from "styled-components";

export const Blob = withTheme(
  ({
    className,
    colour = "peachy",
    shade = "medium",
    opacity = 1,
    height = "100%",
    theme,
  }) => (
    <svg
      className={className}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 838 897"
    >
      <path
        fill={theme.palette[colour][shade]}
        opacity={opacity}
        fillRule="evenodd"
        d="M795.310761,252.694177 C867.236309,443.44706 851.116627,625.105971 712.072427,788.496655 C573.028226,951.88734 259.3955,919.778093 128.072972,759.885817 C-3.24955621,599.993541 -92.2301095,240.427234 163.76911,71.4322315 C419.768329,-97.5627706 723.385212,61.941294 795.310761,252.694177 Z"
      />
    </svg>
  ),
);

export default Blob;
